export default "__VITE_ASSET__cab019c3__"